import type { Lucid } from '../../types/types';

/** Checks if the url starts with either `http://,https://,//,www` */
const isAbsoluteURL = (url: string): url is Lucid.Generic.AbsoluteURL =>
  url.startsWith('http://') || url.startsWith('https://') || url.startsWith('www');

export default isAbsoluteURL;
